import { render, staticRenderFns } from "./view_permission.vue?vue&type=template&id=7dc3caf8&scoped=true"
import script from "./view_permission.vue?vue&type=script&lang=js"
export * from "./view_permission.vue?vue&type=script&lang=js"
import style0 from "./view_permission.vue?vue&type=style&index=0&id=7dc3caf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc3caf8",
  null
  
)

export default component.exports